import React from "react";
import {
  StoryblokComponent,
  storyblokEditable
} from "@storyblok/react";

import LazyHydrate from "@components/utils/LazyHydrate";
import Testimonials from "@components/molecules/Testimonials";
import { getImage } from "@utils/getImage";

import { TestimonialsStoryblokProps } from "./types";

const TestimonialsStoryblok: React.FC<TestimonialsStoryblokProps> = ({
  blok
}) => {
  const {
    items,
    textColor,
    backgroundText,
    withBackgroundAnimation,
    isAnimationActiveOnMobile
  } = blok;

  const carouselItems = items?.map((nestedBlok) => {
    const {
      _uid: key,
      authorAvatar,
      authorDescription,
      authorName
    } = nestedBlok;

    return {
      key,
      slide: <StoryblokComponent blok={nestedBlok} {...{ key }} />,
      author: {
        name: authorName,
        description: authorDescription,
        avatar: getImage(authorAvatar)
      }
    };
  });

  return (
    <LazyHydrate
      useDisplayContents={false}
      noWrapper
      whenVisible
      getEventTarget={() => window}
    >
      <Testimonials
        items={carouselItems}
        color={textColor?.color}
        {...{
          backgroundText,
          withBackgroundAnimation,
          isAnimationActiveOnMobile,
          ...storyblokEditable(blok)
        }}
      />
    </LazyHydrate>
  );
};

export default TestimonialsStoryblok;
